if (!customElements.get('shipping-estimate')) {
  class ShippingEstimate extends HTMLElement {
    constructor() {
      super();
      this.rates = [];
      this.cartUpdateUnsubscriber = undefined;
      this.variantChangeUnsubscriber = undefined;
      this.quantityInput = undefined;
      this.onQuantityChange = this.onQuantityChange.bind(this);
    }

    connectedCallback() {
      this.parseRates();
      this.quantityInput = document.querySelector(`#ProductInfo-${this.dataset.sectionId} .quantity__input`);

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.onCartUpdate.bind(this));
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, this.onVariantChange.bind(this));
      }

      this.quantityInput?.addEventListener('change', this.onQuantityChange);
      this.quantityInput?.addEventListener('input', this.onQuantityChange);
    }

    disconnectedCallback() {
      this.cartUpdateUnsubscriber?.();
      this.variantChangeUnsubscriber?.();
      this.quantityInput?.removeEventListener('change', this.onQuantityChange);
      this.quantityInput?.removeEventListener('input', this.onQuantityChange);
    }

    parseRates() {
      const ratesNode = this.querySelector('[data-shipping-rates]');
      if (!ratesNode) return;

      try {
        this.rates = JSON.parse(ratesNode.textContent);
      } catch (error) {
        this.rates = [];
      }
    }

    onVariantChange(event) {
      const sectionId = event?.data?.sectionId;
      if (sectionId && sectionId !== this.dataset.sectionId) return;

      const variant = event?.data?.variant;
      if (!variant) return;

      this.dataset.quantity = this.getQuantity();
      this.recalculate(parseInt(variant.price, 10), parseInt(this.dataset.cartTotal, 10) || 0);
    }

    onQuantityChange() {
      const variantPrice = this.getVariantPrice();
      if (variantPrice == null) return;

      this.dataset.quantity = this.getQuantity();
      this.recalculate(variantPrice, parseInt(this.dataset.cartTotal, 10) || 0);
    }

    async onCartUpdate(event) {
      let cartTotal = event?.cartData?.total_price;

      if (cartTotal == null) {
        try {
          const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`);
          const cart = await response.json();
          cartTotal = cart.total_price;
          this.dataset.cartItemCount = cart.item_count;
        } catch (error) {
          return;
        }
      }

      this.dataset.cartTotal = cartTotal;

      const variantPrice = this.getVariantPrice();
      if (variantPrice == null) return;

      this.recalculate(variantPrice, cartTotal);
    }

    getQuantity() {
      const value = parseInt(this.quantityInput?.value, 10);
      return Number.isFinite(value) && value > 0 ? value : 1;
    }

    getVariantPrice() {
      const productInfo = document.querySelector(`product-info[data-section="${this.dataset.sectionId}"]`);
      const variantNode = productInfo?.querySelector('[data-selected-variant]');
      if (!variantNode?.textContent) return null;

      try {
        return JSON.parse(variantNode.textContent).price;
      } catch (error) {
        return null;
      }
    }

    getApplicableRates(effectiveTotal, zone) {
      return this.rates.filter((rate) => {
        if (rate.zone !== zone) return false;
        if (effectiveTotal < rate.min) return false;
        if (rate.max != null && effectiveTotal > rate.max) return false;
        return true;
      });
    }

    formatMoney(cents) {
      if (window.Shopify?.formatMoney) {
        return window.Shopify.formatMoney(cents, this.dataset.moneyFormat);
      }

      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: window.Shopify?.currency?.active || 'GBP',
      }).format(cents / 100);
    }

    recalculate(variantPrice, cartTotal) {
      const quantity = this.getQuantity();
      const effectiveTotal = cartTotal + variantPrice * quantity;
      const zone = this.dataset.zone;
      const applicable = this.getApplicableRates(effectiveTotal, zone);
      const label = this.querySelector('[data-shipping-label]');

      if (!label) return;

      if (!applicable.length) {
        this.classList.add('shipping-estimate--unavailable');
        label.textContent = window.shippingEstimateStrings?.viewDeliveryRates || '';
        return;
      }

      applicable.sort((a, b) => a.price - b.price);
      const lowest = applicable[0];
      const zoneLabel = this.dataset.zoneLabel || zone;

      this.classList.remove('shipping-estimate--unavailable');
      label.textContent = (window.shippingEstimateStrings?.deliveryFromShort || '')
        .replace('[zone]', zoneLabel)
        .replace('[price]', this.formatMoney(lowest.price));
    }
  }

  customElements.define('shipping-estimate', ShippingEstimate);
}
